import { render, staticRenderFns } from "./VueConfirmDialog.vue?vue&type=template&id=60dd32ea&scoped=true&"
import script from "./VueConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./VueConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./VueConfirmDialog.vue?vue&type=style&index=0&id=60dd32ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd32ea",
  null
  
)

export default component.exports